/**
 * @exports
 * @class OverlayBox
 */
// @ts-ignore
import anime from 'animejs';

import { get, getInnerHeight } from '../../helpers/utilities';

export class OverlayBox {
    public static selector = '.js-overlay-box';
    private root: Element;
    private content: HTMLElement;
    private inner: HTMLElement;
    private sizer: HTMLElement;

    constructor(root: Element) {
        this.root          = root;
        this.content       = get('.js-overlay-box__content', this.root) as HTMLElement;
        this.inner         = get('.js-overlay-box__inner', this.root) as HTMLElement
        this.sizer         = get('.js-overlay-box__sizer', this.root) as HTMLElement;

        this.bindEvents();
    }


    /**
     * Binds the events for this block.
     * 
     * @private
     * @return void
     */
    private bindEvents(): void {

        // Increase the height of the inner element
        this.content.addEventListener('mouseenter', () => {
            this.setInnerStateTo('open');
        });

        // Increase the height of the inner element
        this.content.addEventListener('mouseleave', () => {
            this.setInnerStateTo('close');
        });
    }


    /**
     * Displays or hides the hover effect for the block
     * 
     * @private
     * @return void
     * @param state Whether to open or close the block
     */
    private setInnerStateTo(state: string): void {
        if(state !== 'open' && state !== 'close') return;

        const defaultHeight = this.sizer.offsetHeight;
        const fullHeight    = getInnerHeight(this.content);
        anime({
            duration: 600,
            height: state === 'open' ? [`${defaultHeight}px`, `${fullHeight}px`] : [`${fullHeight}px`, `${defaultHeight}px`],
            targets: this.inner,
            easing: 'easeInOutCirc',
        });
    }
}
